import { checkJoinEligibility } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { CheckJoinEligibilityServiceResponse } from './check-join-eligibility.dto';
import {
  CheckJoinEligibilityServiceRequestSchema,
  CheckJoinEligibilityServiceResponseSchema,
} from './check-join-eligibility.dto';

export const checkJoinEligibilityService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(CheckJoinEligibilityServiceRequestSchema),

    async (): Promise<CheckJoinEligibilityServiceResponse> => {
      const { data } = await checkJoinEligibility({});

      return {
        eligible: data.eligible,
        restrictionType: data.restrictionType,
      };
    },

    validateServiceResponse(CheckJoinEligibilityServiceResponseSchema),
  ),
);
